/* eslint-disable */
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import dar_pencil from '../../../Assets/images/svg/dar_pencil.svg';
import { removeDefaultStyles } from '../../../Utils/buttonStyle';
import styles from './bufferCalculation.module.scss';
import UseAxios from '../../../Api/http/http';
import { getOverallBuffer } from '../../../Api/request/effortMaster';

const BufferCalculationHeader = ({ editAllEfforts,  hasAccess  }) => {
  const [bufferPercentage, setBufferPercentage] = useState(null);

  useEffect(() => {
    const fetchBuffer = async () => {
      try {
        const response = await UseAxios(getOverallBuffer('buffer', true));
        const bufferArray = response?.data?.data?.bufferEffort;

        if (Array.isArray(bufferArray) && bufferArray.length > 0) {
          setBufferPercentage(bufferArray[0].value);
        }
      } catch (error) {
        console.error('Error fetching buffer:', error);
      }
    };

    fetchBuffer();
  }, []);

  return (
  <div className={styles['bufferCalculation-container']}>
    <div className={styles['bufferCalculation-title1']}>Overall Buffer</div>
    <div className={styles['bufferCalculation-percentage']}>{bufferPercentage}%</div>
    <button 
  style={{
    ...removeDefaultStyles,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: hasAccess('update') ? 'pointer' : 'not-allowed',
    opacity: hasAccess('update') ? 1 : 0.5, 
  }} 
  onClick={editAllEfforts} 
  disabled={!hasAccess('update')}
>

      <img
        src={dar_pencil}
        alt=""
        className={styles['bufferCalculation-pencilIcon']}
      />
    </button>
  </div>
)
};

BufferCalculationHeader.propTypes = {
  editAllEfforts: PropTypes.func.isRequired,
  hasAccess: PropTypes.func.isRequired,
};

export default BufferCalculationHeader;
